import Vue from 'vue'
import Router from 'vue-router'

// 移动端隐私政策界面
const PrivacyPolicy = () => import(/* webpackChunkName: "PrivacyPolicy" */ 'src/view/privacyPolicy/Index')

const loginIndex = () => import(/* webpackChunkName: "Login" */ 'src/view/login/Index')
const registerIndex = () => import(/* webpackChunkName: "Regist" */ 'src/view/register/Index')
const companyinfoconfigIndex = () => import(/* webpackChunkName: "Regist" */ 'src/view/companyinfoconfig/Index')
const UpdatePsd = () => import(/* webpackChunkName: "Regist" */ 'src/view/updatePsd/Index')

// 多模块切换展示
const MultiModule = () => import(/* webpackChunkName: "MultiModule" */'@/view/multimodule/Index')
// 工作台
const cockpitIndex = () => import(/* webpackChunkName: "cockpitIndex" */ '@/view/cockpit/Index')
// 运行日报
const OperationReportIndex = () => import(/* webpackChunkName: "OperationReportIndex" */ 'src/view/operationreport/Index')
const OperationReportConfig = () => import(/* webpackChunkName: "OperationReportConfig" */ 'src/view/operationreport/config/Index')

// 设备监控界面(bimface)
const EquMonitorIndex = () => import(/* webpackChunkName: "EquMonitorIndex" */ '@/view/equmonitor/Index')
// bim获取构件信息的工具
const BimTool = () => import(/* webpackChunkName: "BimTool" */ '@/view/bimTool/Index')
// bim设置漫游工具
const BimWalkTool = () => import(/* webpackChunkName: "BimWalkTool" */ 'src/view/bim/Index')

// 巡检记录
const PatrolRecordIndex = () => import(/* webpackChunkName: "PatrolRecordIndex" */ '@/view/patrolmanage/patrolrecord/Index')
const InspectTaskLog = () => import(/* webpackChunkName: "InspectTaskLog" */ '@/view/inspect/tasklog/Index')
const InspectLog = () => import(/* webpackChunkName: "InspectLog" */ '@/view/inspect/log/Index')
const InspectDetails = () => import(/* webpackChunkName: "InspectDetails" */ '@/view/inspect/log/Details')
const InspectTrajectory = () => import(/* webpackChunkName: "InspectTrajectory" */ '@/view/inspect/log/Trajectory')
const InspectPlanLook = () => import(/* webpackChunkName: "InspectPlanLook" */ '@/view/inspect/plan/look')

// 视频监控
const CameraIndex = () => import(/* webpackChunkName: "CameraIndex" */ '@/view/videosurveillance/CameraIndex')
const CameraManage = () => import(/* webpackChunkName: "CameraManage" */ '@/view/videosurveillance/CameraManage')
const CameraAdd = () => import(/* webpackChunkName: "CameraAdd" */ '@/view/videosurveillance/CameraAdd')
// const VideoList = () => import(/* webpackChunkName: "VideoList" */ '@/view/videosurveillance/VideoList')
const NewVideoList = () => import(/* webpackChunkName: "NewVideoList" */ '@/view/videosurveillance/VideoListNew')
// const VideoDetail = () => import(/* webpackChunkName: "VideoDetail" */ '@/view/videosurveillance/VideoDetail')
const NewVideoDetail = () => import(/* webpackChunkName: "NewVideoDetail" */ '@/view/videosurveillance/VideoDetailNew')
const VideoSettings = () => import(/* webpackChunkName: "VideoSettings" */ '@/view/videosurveillance/VideoSettings')
const VideoImgList = () => import(/* webpackChunkName: "VideoImgList" */ '@/view/videosurveillance/VideoImgList')

// 预置点管理
const PresetManage = () => import(/* webpackChunkName: "PresetManage" */ '@/view/videosurveillance/PresetManage')
// 账号管理
const CameraAccountManage = () => import(/* webpackChunkName: "CameraAccountManage" */ '@/view/videosurveillance/CameraAccountManage')
// 定期任务
const TaskManage = () => import(/* webpackChunkName: "TaskManage" */ '@/view/videosurveillance/TaskManage')

// 微信公众号的任务推送和账号绑定
const WechatTaskIndex = () => import(/* webpackChunkName: "WechatTaskIndex" */ '@/view/wechat/Index')
const WechatTaskDetail = () => import(/* webpackChunkName: "WechatTaskDetail" */ '@/view/wechat/TaskDetail')
const WetchatLogin = () => import(/* webpackChunkName: "WechatLogin" */ '@/view/wechat/Login')

// 项目看板
const Workbench = () => import(/* webpackChunkName: "Workbench" */ '@/view/workbench/Index')

// bim模块
const BimIndex = () => import(/* webpackChunkName: "BimIndex" */ '@/view/bim/Index')

// GIS地图
const GISIndex = () => import(/* webpackChunkName: "GISIndex" */ '@/view/gis/Index')

// 抄表管理模块相关
const MeterReadingIndex = () => import(/* webpackChunkName: "MeterReadingIndex" */ '@/view/meterReading/Index')
const MeterReadingConfig = () => import(/* webpackChunkName: "MeterReadingConfig" */ '@/view/meterReading/config/Index')
const MeterReadingZero = () => import(/* webpackChunkName: "MeterReadingZero" */ '@/view/meterReading/zero/Index')
const MeterReadingZeroDetail = () => import(/* webpackChunkName: "MeterReadingZeroDetail" */ '@/view/meterReading/zero/Detail')
const MeterReadingHandover = () => import(/* webpackChunkName: "MeterReadingHandover" */ '@/view/meterReading/handover/Index')
const MeterReadingHandoverDetail = () => import(/* webpackChunkName: "MeterReadingHandoverDetail" */ '@/view/meterReading/handover/Detail')
const MeterReadingDoData = () => import(/* webpackChunkName: "MeterReadingDoData" */ '@/view/meterReading/doData/Index')
const MeterReadingDoDataDetail = () => import(/* webpackChunkName: "MeterReadingDoDataDetail" */ '@/view/meterReading/doData/Detail')

const MeterReadingOnlineData = () => import(/* webpackChunkName: "MeterReadingOnlineData" */ '@/view/meterReading/online/Index')
const MeterReadingOnlineDetail = () => import(/* webpackChunkName: "MeterReadingOnlineData" */ '@/view/meterReading/online/Detail')
const MeterReadingEquTime = () => import(/* webpackChunkName: "MeterReadingOnlineData" */ '@/view/meterReading/equTime/Index')
const MeterReadingEquTimeDetail = () => import(/* webpackChunkName: "MeterReadingOnlineData" */ '@/view/meterReading/equTime/Detail')

// 报表模板管理
const ReportFormTemplateManage = () => import(/* webpackChunkName: "ReportFormTemplateManage" */ '@/view/reportForm/templateManage/Index')

// 项目管理
const ProjectManageIndex = () => import(/* webpackChunkName: "ProjectManageIndex" */ '@/view/projectManage/Index')
const BasicInfo = () => import(/* webpackChunkName: "BasicInfo" */ '@/view/projectManage/basicInfo/Index')
const PostManageIndex = () => import(/* webpackChunkName: "PostManageIndex" */ '@/view/projectManage/postManage/Index')
const GroupManageIndex = () => import(/* webpackChunkName: "GroupManageIndex" */ '@/view/projectManage/groupManage/Index')
const OutsourcingUnit = () => import(/* webpackChunkName: "OutsourcingUnit" */ '@/view/projectManage/outsourcingUnit/Index')

// 设备管理
const DeviceManagementIndex = () => import(/* webpackChunkName: "DeviceManagementIndex" */ '@/view/deviceManagement/Index')
const DeviceStatusList = () => import(/* webpackChunkName: "DeviceStatusList" */ '@/view/deviceManagement/statusList/Index')
const BreakdownRecordList = () => import(/* webpackChunkName: "BreakdownRecordList" */ '@/view/deviceManagement/breakdownRecord/Index')
const FaultAnalysis = () => import(/* webpackChunkName: "FaultAnalysis" */ '@/view/deviceManagement/faultAnalysis/Index')
const RunAnalysis = () => import(/* webpackChunkName: "RunAnalysis" */ '@/view/deviceManagement/runAnalysis/Index')

// 水质管理
const WaterQualityIndex = () => import(/* webpackChunkName: "WaterQualityIndex" */ '@/view/waterQuality/Index')
const WaterQualityQuery = () => import(/* webpackChunkName: "WaterQualityIndex" */ '@/view/waterQuality/query/Index')
const WaterQualityTrend = () => import(/* webpackChunkName: "WaterQualityIndex" */ '@/view/waterQuality/trend/Index')

// 水量管理
const waterYieldIndex = () => import(/* webpackChunkName: "waterYieldIndex" */ '@/view/waterYield/Index')
const waterYieldAll = () => import(/* webpackChunkName: "waterYieldAll" */ '@/view/waterYield/All/Index')

// 计划管理
const PlanManageIndex = () => import(/* webpackChunkName: "PlanManageIndex" */ '@/view/planManage/Index')
const WaterMeterIndex = () => import(/* webpackChunkName: "WaterMeterIndex" */ '@/view/planManage/waterMeter/Index')
const ProductionIndex = () => import(/* webpackChunkName: "ProductionIndex" */ '@/view/planManage/production/Index')
const ProgressIndex = () => import(/* webpackChunkName: "ProgressIndex" */ '@/view/planManage/progress/Index')
const TodayPlanIndex = () => import(/* webpackChunkName: "TodayPlanIndex" */ '@/view/planManage/todayPlan/Index')

// 排泥管理
const MudIndex = () => import(/* webpackChunkName: "MudIndex" */ '@/view/mudManage/Index')
const MudPrice = () => import(/* webpackChunkName: "MudPrice" */ '@/view/mudManage/MudPrice')

// 药剂管理
const MedicamentIndex = () => import(/* webpackChunkName: "MedicamentIndex" */ '@/view/medicamentManage/Index')
const MedicamentPrice = () => import(/* webpackChunkName: "MedicamentPrice" */ '@/view/medicamentManage/MedicamentPrice')

// 仓库管理
const DepositoryMgt = () => import(/* webpackChunkName: "DepositoryMgt" */ '@/view/depositoryMgt/Index.vue')
const Depository = () => import(/* webpackChunkName: "Depository" */ '@/view/depositoryMgt/depository/Index.vue')
const Material = () => import(/* webpackChunkName: "Material" */ '@/view/depositoryMgt/material/Index.vue')
const SearchInboundRecord = () => import(/* webpackChunkName: "SearchInboundRecord" */ '@/view/depositoryMgt/searchInboundRecord/Index.vue')
const SearchOutboundRecord = () => import(/* webpackChunkName: "SearchOutboundRecord" */ '@/view/depositoryMgt/searchOutboundRecord/Index.vue')
const LossMgt = () => import(/* webpackChunkName: "LossMgt" */ '@/view/depositoryMgt/lossMgt/Index.vue')
const searchInventory = () => import(/* webpackChunkName: "searchInventory" */ '@/view/depositoryMgt/searchInventory/Index.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/privacyPolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/login/:loginurl',
      name: 'Login',
      component: loginIndex
    },
    {
      path: '/register',
      name: 'Register',
      component: registerIndex
    },
    {
      path: '/corp/toUpdateCorp',
      name: 'companyinfoconfig',
      component: companyinfoconfigIndex
    },
    {
      path: '/toUpdatePsd',
      name: 'UpdatePsd',
      component: UpdatePsd
    },
    {
      path: '/map/init',
      name: 'GISIndex',
      component: GISIndex
    },
    {
      path: '/multiModule',
      name: 'MultiModule',
      component: MultiModule,
      props: (route) => ({
        projectId: route.query.projectId
      }),
      children: [
        {
          path: 'workBench',
          name: 'Workbench',
          component: Workbench
        },
        {
          path: 'bim',
          name: 'BimIndex',
          component: BimIndex
        }
      ]
    },
    {
      path: '/projectinfo/cockpit',
      name: 'cockpit',
      component: cockpitIndex
    },
    {
      path: '/paper/OperationReportIndex',
      name: 'OperationReport',
      component: OperationReportIndex
    },
    {
      path: '/paper/operationReportConfig',
      name: 'OperationReportConfig',
      component: OperationReportConfig
    },
    {
      path: '/model/runMonitor',
      name: 'EquMonitor',
      component: EquMonitorIndex,
      props: (route) => ({
        projectId: route.query.projectId
      })
    },
    {
      path: '/bim/tool', // 获取bim构件信息的工具(仅供研发自己用，不对用户开放)
      name: 'BimTool',
      component: BimTool
    },
    {
      path: '/inspect/patrol_record',
      name: 'PatrolRecordIndex',
      component: PatrolRecordIndex
    },
    {
      path: '/inspect/tasklog',
      name: 'InspectTaskLog',
      component: InspectTaskLog
    },
    {
      path: '/inspect/log',
      name: 'InspectLog',
      component: InspectLog
    },
    {
      path: '/inspect/Details',
      name: 'InspectDetails',
      component: InspectDetails
    },
    {
      path: '/inspect/Trajectory',
      name: 'InspectTrajectory',
      component: InspectTrajectory
    },
    {
      path: '/inspect/plan/look',
      name: 'InspectPlanLook',
      component: InspectPlanLook
    },
    {
      path: '/camera',
      name: 'camera',
      component: CameraIndex,
      children: [
        {
          path: 'toCamera',
          name: 'CameraManage',
          component: CameraManage
        },
        {
          path: 'add',
          name: 'CameraAdd',
          component: CameraAdd
        },
        {
          path: 'detail',
          name: 'CameraDetail',
          component: CameraAdd,
          props: (route) => ({
            id: route.query.id,
            detail: route.query.detail,
            backBtnRouter: route.query.backBtnRouter
          })
        },
        {
          path: 'edit',
          name: 'CameraEdit',
          component: CameraAdd,
          props: (route) => ({
            id: route.query.id
          })
        },
        {
          path: 'toPreset',
          name: 'PresetManage',
          component: PresetManage
        },
        {
          path: 'toCameraAccount',
          name: 'CameraAccountManage',
          component: CameraAccountManage
        },
        {
          path: 'toTask',
          name: 'TaskManage',
          component: TaskManage
        },
        {
          path: 'toTaskPic',
          name: 'TaskPicManage',
          component: TaskManage
        },
        {
          path: 'toVideoList',
          name: 'VideoList',
          component: NewVideoList,
          props: (route) => ({
            pageURL: route.query.pageURL
          })
        },
        {
          path: 'toNewVideoList',
          name: 'NewVideoList',
          component: NewVideoList,
          props: (route) => ({
            pageURL: route.query.pageURL
          })
        },
        {
          path: 'videoDetail',
          name: 'VideoDetail',
          component: NewVideoDetail,
          props: (route) => ({
            id: route.query.id,
            presetId: route.query.presetId
          })
        },
        {
          path: 'newVideoDetail',
          name: 'NewVideoDetail',
          component: NewVideoDetail,
          props: (route) => ({
            id: route.query.id,
            presetId: route.query.presetId
          })
        },
        {
          path: 'videoSettings',
          name: 'VideoSettings',
          component: VideoSettings,
          props: (route) => ({
            id: route.query.id,
            name: route.query.name
          })
        },
        {
          path: 'videoImgList',
          name: 'VideoImgList',
          component: VideoImgList,
          props: (route) => ({
            id: route.query.id,
            name: route.query.name,
            presetId: route.query.presetId,
            labelName: route.query.labelName
          })
        }
      ]
    },
    {
      path: '/wechat',
      name: '',
      component: WechatTaskIndex,
      children: [
        {
          path: 'userAuthCode',
          name: 'wechatLogin',
          component: WetchatLogin,
          props: (route) => ({
            code: route.query.code,
            appId: route.query.state
          })
        },
        {
          path: 'cameraInfo',
          name: 'wechatCameraInfo',
          component: WechatTaskDetail,
          props: (route) => ({
            projectId: route.query.projectId,
            cameraTaskId: route.query.cameraTaskId,
            date: route.query.date,
            time: route.query.time,
            fromApp: route.query.fromApp // 是否来自手机app,默认为false
          })
        }
      ]
    },
    {
      path: '/bim/bimWalkTool',
      name: 'bimWalkTool',
      component: BimWalkTool
    },
    {
      path: '/meterReading',
      name: 'MeterReadingIndex',
      component: MeterReadingIndex,
      children: [
        {
          path: 'config',
          name: 'MeterReadingConfig',
          component: MeterReadingConfig
        },
        {
          path: 'zero',
          name: 'MeterReadingZero',
          component: MeterReadingZero
        },
        {
          path: 'zeroDetail',
          name: 'MeterReadingZeroDetail',
          component: MeterReadingZeroDetail,
          props: (route) => ({
            id: route.query.id,
            type: route.query.type
          })
        },
        {
          path: 'handover',
          name: 'MeterReadingHandover',
          component: MeterReadingHandover
        },
        {
          path: 'handoverDetail',
          name: 'MeterReadingHandoverDetail',
          component: MeterReadingHandoverDetail,
          props: (route) => ({
            id: route.query.id,
            type: route.query.type
          })
        },
        {
          path: 'doData',
          name: 'MeterReadingDoData',
          component: MeterReadingDoData
        },
        {
          path: 'doDataDetail',
          name: 'MeterReadingDoDataDetail',
          component: MeterReadingDoDataDetail,
          props: (route) => ({
            id: route.query.id,
            type: route.query.type
          })
        },
        {
          path: 'online',
          name: 'MeterReadingOnlineData',
          component: MeterReadingOnlineData
        },
        {
          path: 'onlineDetail',
          name: 'MeterReadingOnlineDetail',
          component: MeterReadingOnlineDetail,
          props: (route) => ({
            id: route.query.id,
            type: route.query.type
          })
        },
        {
          path: 'equTime',
          name: 'MeterReadingEquTime',
          component: MeterReadingEquTime
        },
        {
          path: 'equTimeDetail',
          name: 'MeterReadingEquTimeDetail',
          component: MeterReadingEquTimeDetail,
          props: (route) => ({
            id: route.query.id,
            type: route.query.type
          })
        }
      ]
    },
    {
      path: '/reportForm/templateManage',
      name: 'ReportFormTemplateManage',
      component: ReportFormTemplateManage
    },
    {
      path: '/projectManage',
      name: 'ProjectManage',
      component: ProjectManageIndex,
      children: [
        {
          path: 'outsourcingUnit',
          name: 'OutsourcingUnit',
          component: OutsourcingUnit
        },
        {
          path: 'basicInfo',
          name: 'BasicInfo',
          component: BasicInfo
        },
        {
          path: 'postManage',
          name: 'PostManageIndex',
          component: PostManageIndex
        },
        {
          path: 'groupManage',
          name: 'GroupManageIndex',
          component: GroupManageIndex
        }
      ]
    },
    {
      path: '/deviceManagement',
      name: 'DeviceManagement',
      component: DeviceManagementIndex,
      children: [
        {
          path: 'statusList',
          name: 'DeviceStatusList',
          component: DeviceStatusList
        },
        {
          path: 'breakdownRecordList',
          name: 'BreakdownRecordList',
          component: BreakdownRecordList
        },
        {
          path: 'faultAnalysis',
          name: 'FaultAnalysis',
          component: FaultAnalysis
        },
        {
          path: 'runAnalysis',
          name: 'RunAnalysis',
          component: RunAnalysis
        }
      ]
    },
    {
      path: '/planManage',
      name: 'PlanManageIndex',
      component: PlanManageIndex,
      children: [
        {
          path: 'waterMeter',
          name: 'WaterMeterIndex',
          component: WaterMeterIndex
        },
        {
          path: 'productionPlan',
          name: 'ProductionIndex',
          component: ProductionIndex
        },
        {
          path: 'planProgress',
          name: 'ProgressIndex',
          component: ProgressIndex
        },
        {
          path: 'todayPlan',
          name: 'TodayPlanIndex',
          component: TodayPlanIndex
        }
      ]
    },
    {
      path: '/waterQuality',
      name: 'WaterQualityIndex',
      component: WaterQualityIndex,
      children: [
        {
          path: 'queryAnalysis',
          name: 'WaterQualityQuery',
          component: WaterQualityQuery
        },
        {
          path: 'trendAnalysis',
          name: 'WaterQualityTrend',
          component: WaterQualityTrend
        }
      ]
    },
    {
      path: '/waterYield',
      name: 'waterYieldIndex',
      component: waterYieldIndex,
      children: [
        {
          path: 'all',
          name: 'waterYieldAll',
          component: waterYieldAll
        }
      ]
    },
    {
      path: '/mud',
      name: 'MudIndex',
      component: MudIndex,
      children: [
        {
          path: 'price',
          name: 'MudPrice',
          component: MudPrice
        }
      ]
    },
    {
      path: '/medicament',
      name: 'MedicamentIndex',
      component: MedicamentIndex,
      children: [
        {
          path: 'price',
          name: 'MedicamentPrice',
          component: MedicamentPrice
        }
      ]
    },
    {
      path: '/depositoryMgt',
      name: 'DepositoryMgt',
      component: DepositoryMgt,
      redirect: 'depositoryMgt/depository',
      children: [
        {
          path: 'toDepository',
          name: 'Depository',
          component: Depository,
        },
        {
          path: 'toMaterial',
          name: 'Material',
          component: Material,
        },
        {
          path: 'tosearchInboundRecord',
          name: 'SearchInboundRecord',
          component: SearchInboundRecord,
        },
        {
          path: 'toSearchOutboundRecord',
          name: 'SearchOutboundRecord',
          component: SearchOutboundRecord,
        },
        {
          path: 'toLossMgt',
          name: 'LossMgt',
          component: LossMgt,
        },
        {
          path: 'toSearchInventory',
          name: 'searchInventory',
          component: searchInventory,
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/project_web/router/index.js